import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const CountriesRoutes: Routes = [
  {
    path: "countries",
    loadComponent: () =>
      import("./countries/countries.component").then(
        (m) => m.CountriesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./country-list/country-list.component").then(
            (m) => m.CountryListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./country-form/country-form.component").then(
            (m) => m.CountryFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./country-form/country-form.component").then(
            (m) => m.CountryFormComponent,
          ),
      },
    ],
  },
];
